import { createApp, h } from 'vue';
import Toast from './index.vue';
import Loading from './Loading.vue';
import Mess from './mess.vue';
let toastContainer = null;
let loadingContainer = null;
let loadingApp = null;

function createToastContainer() {
  toastContainer = document.createElement('div');
  toastContainer.id = 'toast-container';
  document.body.appendChild(toastContainer);
}

function createMess() {
  toastContainer = document.createElement('div');
  toastContainer.id = 'toast-mess';
  document.body.appendChild(toastContainer);
}
function createLoadingContainer() {
  loadingContainer = document.createElement('div');
  loadingContainer.id = 'loading-container';
  document.body.appendChild(loadingContainer);
}

function showMess(messData, duration =3000) {
  if (!toastContainer) {
    createMess();
  }

  const app = createApp({
    render() {
      return h(Mess, {
        messData,
        duration
      });
    }
  });

  const vnode = app.mount(toastContainer);

  // 在 duration 后移除 Toast 组件  
  setTimeout(() => {
    app.unmount(toastContainer);
    // 如果容器内没有其他 Toast，可以移除容器本身
    if (toastContainer.innerHTML === '') {
      toastContainer.remove();
      toastContainer = null;
    }
  }, duration);
}
function showToast(message, duration = 3000) {
  if (!toastContainer) {
    createToastContainer();
  }

  const app = createApp({
    render() {
      return h(Toast, {
        message,
        duration
      });
    }
  });

  const vnode = app.mount(toastContainer);

  // 在 duration 后移除 Toast 组件  
  setTimeout(() => {
    app.unmount(toastContainer);
    // 如果容器内没有其他 Toast，可以移除容器本身
    if (toastContainer.innerHTML === '') {
      toastContainer.remove();
      toastContainer = null;
    }
  }, duration);
}

function showLoading(message = '') {
  if (!loadingContainer) {
    createLoadingContainer();
  }

  if (loadingApp) {
    loadingApp.unmount();
  }

  loadingApp = createApp({
    render() {
      return h(Loading, {
        visible: true,
        message
      });
    }
  });

  loadingApp.mount(loadingContainer);
}

function hideLoading() {
  if (loadingContainer && loadingApp) {
    loadingApp.unmount();

    setTimeout(() => {
      loadingContainer.remove();
      loadingContainer = null;
      loadingApp = null;
    }, 300); // 延迟移除以确保动画完成
  }
}

export { showToast, showLoading, hideLoading,showMess };